import { Action } from '@ngrx/store';

import { SiteLogoActionType } from './site-logo-action-type.enum';

export class LoadSiteLogo implements Action {
  public readonly type: SiteLogoActionType = SiteLogoActionType.LoadSiteLogo;

  public readonly payload: any = undefined;
}

export class LoadSiteLogoCompleted implements Action {
  public readonly type: SiteLogoActionType = SiteLogoActionType.LoadSiteLogoCompleted;

  constructor(public readonly payload: string) { }
}

export class LoadSiteLogoFailed implements Action {
  public readonly type: SiteLogoActionType = SiteLogoActionType.LoadSiteLogoFailed;

  constructor(public readonly payload: string) { }
}
export class UpdateSiteLogo implements Action {
  public readonly type: SiteLogoActionType = SiteLogoActionType.UpdateSiteLogo;

  constructor(public readonly payload: string) { }
}

export class UpdateSiteLogoCompleted implements Action {
  public readonly type: SiteLogoActionType = SiteLogoActionType.UpdateSiteLogoCompleted;

  constructor(public readonly payload: string) { }
}

export class UpdateSiteLogoFailed implements Action {
  public readonly type: SiteLogoActionType = SiteLogoActionType.UpdateSiteLogoFailed;

  constructor(public readonly payload: string) { }
}

export class DeleteSiteLogo implements Action {
  public readonly type: SiteLogoActionType = SiteLogoActionType.DeleteSiteLogo;

  public readonly payload: any = undefined;
}

export class DeleteSiteLogoCompleted implements Action {
  public readonly type: SiteLogoActionType = SiteLogoActionType.DeleteSiteLogoCompleted;

  public readonly payload: any = undefined;
}

export class DeleteSiteLogoFailed implements Action {
  public readonly type: SiteLogoActionType = SiteLogoActionType.DeleteSiteLogoFailed;

  constructor(public readonly payload: string) { }
}
